import { computed, ref } from 'vue'

/** Module-level FCM status — safe to import from useAuth/http without pulling in useFCM. */
export const fcmStatus = ref({
  isSupported: false,
  permission: 'default',
  tokenStatus: 'none',
  token: null,
  lastError: null,
  isProcessing: false,
  firstInit: false,
})

export const notificationToken = computed(() => fcmStatus.value.token)
